import React from 'react';
import { DisplayField } from 'hellospa/components/signature-request';
import { useSignerTextInput } from './text-field-hooks';
import { isMultilineField } from '../editor/utils';

const TAB = 9;

function TextField({
  updateField, onChange, fieldData, getInstantValidationErrorHack, isOverlay,
  documentPreview, ...props
}, ref) {
  const hidden = React.useRef();

  const style = {
    whiteSpace: isMultilineField(fieldData) ? 'pre-wrap' : 'pre',
    wordBreak: 'break-word',
    wordSpacing: '0.05em !important',
    letterSpacing: '0.05em',
  };


  let locationName = 'signer';
  if (isOverlay) {
    locationName = 'overlay';
  } else if (documentPreview) {
    locationName = 'preview';
  }

  useSignerTextInput(
    fieldData,
    (ref.current ? ref.current.textRef : undefined),
    (hidden.current ? hidden.current.textRef : undefined),
    updateField,
    locationName,
  );

  const handleChange = (e) => {
    if (!isMultilineField(fieldData) && e.target.value.indexOf('\n') >= 0) {
      return;
    }

    // Prevent accepting spaces with no other text
    if (e.target.value.trim().length === 0) {
      e.target.value = '';
    }
    onChange(e);
  };

  const handleKeyDown = (evt) => {
    if ((evt.which || evt.keyCode) === TAB) {
      const validationError = getInstantValidationErrorHack(fieldData.id);

      if (validationError) {
        evt.preventDefault();
      }
    }
  };

  const [focused, setFocus] = React.useState(false);

  // DisplayField isn't memoized, so React.useCallback doesn't provide any benefit here.
  const handleBlur = () => { setFocus(false); };
  const handleFocus = () => { setFocus(true); };

  const value = fieldData.value || '';

  return (
    <React.Fragment>
      <DisplayField
        {...props}
        placeholder={fieldData.placeholder || ''}
        fieldData={!focused && fieldData.masked ? {
          ...fieldData,
          value: value.replace(/./gi, '*'),
        } : fieldData}
        ref={ref}
        style={style}
        onKeyDown={handleKeyDown}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur} />
      <div style={{
        position: 'absolute',
        top: '100%',
        height: '100%',
        width: '100%',
        visibility: 'hidden',
      }}
      >
        <DisplayField
          {...props}
          fieldData={fieldData}
          style={{
            ...style,
            minHeight: 0,
            height: 0,
          }}
          placeholder={
            // do not apply placeholders here, it makes this field too wide and
            // breaks the auto-resizing code.
            ''
          }
          data-qa-ref={undefined}
          ref={hidden} />
      </div>
    </React.Fragment>
  );

}

export default React.forwardRef(TextField);
